import React, { useEffect, useState } from "react";
// import { useLazyPostSomethingMutation } from "../store/api"; // RTK query mutation
import logo from "../../assets/icons//MocionLogoBlue.svg";
import Button from "./Button";
const ProgressModal = ({
  isLoadingMatches,
  loadingModalTitle,
}: {
  isLoadingMatches: boolean;
  loadingModalTitle: string;
}) => {
  //   const [trigger, { isLoading, isSuccess }] = useLazyPostSomethingMutation();
  const [isLoading, setIsloading] = useState(isLoadingMatches);
  const [isSuccess, setIsSuccess] = useState(false);
  const [progress, setProgress] = useState(0);

  // useEffect(() => {
  //   let interval: NodeJS.Timeout;

  //   interval = setInterval(() => {
  //     setIsloading(false);
  //     setIsSuccess(true);
  //   }, 30000); // update every 1min

  //   return () => clearInterval(interval);
  // }, [isLoading, isSuccess]);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isLoading) {
      setProgress(0);
      interval = setInterval(() => {
        setProgress((old) => {
          if (old < 90) return old + 1; // slowly fill to 90%
          return old;
        });
      }, 750); // update every 0.5s
    }

    if (!isLoading) {
      setProgress(100);
      //   setTimeout(() => setProgress(0), 2000); // reset after 2s
    }

    return () => clearInterval(interval);
  }, [isLoading]);

  return (
    <div className="p-10">
      <div className="flex flex-col justify-center items-center gap-4">
        <img
          loading="lazy"
          width={200}
          height={200}
          src={logo}
          alt="mocion-logo"
        />

        <h2 className={` text-3xl text-primary dark:text-white  `}>
          {loadingModalTitle}
        </h2>
        <p
          className={`text-base font-normal  text-primary dark:text-white break-words leading-relaxed whitespace-pre-wrap `}
        >
          it will take up to 2 min, Please stay on this page
        </p>
        <div className="w-full flex flex-col items-center">
          {isLoading && (
            <div className="mt-4 w-[70%] bg-gray-200 rounded-full h-3">
              <div
                className="bg-[#172B85] h-3 rounded-full transition-all duration-300"
                style={{ width: `${progress}%` }}
              />
            </div>
          )}

          {isLoading && (
            <p className="text-sm mt-2 text-center">
              {progress}% Processing...
            </p>
          )}
          {!isLoading && (
            <p className="text-primaryGreen mt-2 text-center">Completed!</p>
          )}
        </div>
        <Button
          customeStyle={`bg-white font-bold text-primary dark:text-white dark:bg-primary  w-full rounded-full border border-primary hover:bg-[#f3f3f3]  text-base py-3 `}
          text={"cancel"}
          width="max-w-[400px] w-[70%]"
          onClick={() => {
            window.location.reload();
          }}
        />
      </div>
    </div>
  );
};

export default ProgressModal;
